// Left visual panel for MultiStepForm — a light stage holding a
// perspective-tilted preview card (pass the mock as children). Hidden below the
// ~900px breakpoint so the form takes the full width on narrow screens.
export default function WizardAside({ children }) {
  return (
    <div className="relative hidden flex-1 basis-1/2 overflow-hidden border-r border-line bg-panel min-[900px]:block">
      <div className="absolute inset-0 flex items-center overflow-hidden pl-[7%] [perspective:1800px]">
        <div className="w-[132%] origin-left [transform:rotateY(24deg)_rotateX(6deg)_rotateZ(-3deg)] [filter:drop-shadow(0_30px_60px_rgba(2,6,23,0.14))] dark:[filter:drop-shadow(0_30px_60px_rgba(0,0,0,0.5))]">
        {children}
        </div>
      </div>
    </div>
  )
}
